<template>

    <section class="mentor-selector">
        <div class="modal-wrapper" v-if="selectedMentor" @click="selectedMentor=null">
            <div class="modal-box" @click.stop :style="{ backgroundImage: 'url(' + selectedMentor.featuredImage + ')' }">
                <img :src="selectedMentor.avatar" class="avatar">
                <h3>{{selectedMentor.user.firstName}} {{selectedMentor.user.lastName}}</h3>
                <div class="template-selector">
                  <span>Template</span>
                  <ol>
                    <li
                      :class="{ selected: index === requestTemplateSelected }"
                      v-for="(tmpl, index) in requestTemplates">
                      <button
                        type="button"
                        :disabled="submittingRequest"
                        @click="setRequestTemplate(index)">
                        {{String.fromCharCode(65 + index)}}
                      </button>
                    </li>
                  </ol>
                </div>
                <textarea
                  :disabled="submittingRequest"
                  v-model="request">
                </textarea>
                <file-select
                  multiple
                  :disabled="submittingRequest"
                  v-model="requestFiles">
                </file-select>
                <button
                  class="btn btn-success"
                  :disabled="submittingRequest"
                  @click.prevent="sendRequest()">
                  {{submittingRequest ? 'Submitting...' : 'Submit'}}
                </button>
            </div>
        </div>
        <div class="panel">
            <div class="panel-heading"><h2>Discover Your Mentor</h2></div>
            <div class="panel-body">
                <h3 class="disabled" v-if="!connectionAllowed">Mentor Selections will become available closer to the Mentorship Term.<br>You will be notified once this function becomes available.</h3>

                <div class="selector">
                    
                    <div v-if="canSeeVenueOptions">
                        <div class="form-group" v-if="!isDirector">
                            <select v-model="venueFilter">
                                <option v-if="!localStorage.roles.includes('Student')" value="both">Online &amp; On-Campus <span v-if="localStorage.path == '9200'">Houdini</span> Mentors</option>
                                <option value="online">Online <span v-if="localStorage.path == '9200'">Houdini</span> Mentors</option>
                                <option value="campus">On-Campus <span v-if="localStorage.path == '9200'">Houdini</span> Mentors</option>
                            </select>
                        </div>
                        <div class="form-group" v-if="isDirector">
                            <select v-model="venueFilter">
                                <option value="both">Online &amp; On-Campus Mentors</option>
                                <option value="online">Online Mentors</option>
                                <option value="campus">On-Campus Mentors</option>
                            </select>
                        </div>
                        <div class="form-group" v-if="isDirector">
                            <select v-model="pathFilter">                       
                                <option value="cgasset">CG Asset Mentors</option>         
                                <option value="houdini">Houdini Mentors</option>                                
                            </select>
                        </div>
                    </div>
               
                    <div class="filters">
                        Works in the
                        <select v-model="perfectMatch.industry">
                            <option value="" default selected>choose</option>
                            <option value="vfx">VFX / Film & TV Industry</option>
                            <option value="video_games">Video Game Industry</option>
                        </select>,
                        that is available

                        <select v-model="perfectMatch.availableDays">
                            <option value="" default selected>choose</option>
                            <option value="weekdays">during the week</option>
                            <option value="weekends">during the weekends</option>
                            <option value="both">anytime of the week</option>
                        </select>,

                        <select v-model="perfectMatch.availableTimes">
                            <option value="" default selected>choose</option>
                            <option value="mornings">in the mornings</option>
                            <option value="afternoons">in the afternoons</option>
                            <option value="evenings">in the evenings</option>
                            <option value="any">anytime of the day</option>
                        </select>,


                        <br>That specializes in:

                        <ul class="specialties">
                            <li v-for="specialty in specialties">
                                <input
                                :checked="perfectMatch.specialties.indexOf(specialty) > -1"
                                type="checkbox"
                                :id="specialty"
                                :value="specialty"
                                v-model="perfectMatch.specialties">
                                <label :for="specialty">
                                    {{specialty | deslugify}}
                                </label>
                            </li>
                        </ul>
                        <div class="form-group term-selector">
                        Term: <select @change="getMentors()" v-model="selectedTerm" class="form-control">
                                <option v-for="term in terms" :value="term.id">
                                    {{term.name.split(',')[1].trim()}}
                                </option>
                            </select>                        
                        </div>
                    </div>

                    </div>
                    <div v-if="loading">
                        <loader></loader>
                    </div>
                    <ul class="mentors" v-if="mentors">

                        <li
                        v-for="mentor in mentors"
                        v-show="selectionHasNotStarted || mentor.percentage > 0"
                        v-if="showMentor(mentor)"
                        >
                            <router-link :to="{name: 'mentorProfile', params:{id: mentor.user.id}}">

                            <div class="mentor" :class="{'unavailable': isNotAvailable(mentor)}">
                                <div class="row">
                                    <div class="col-xs-3 nopad avatar-wrapper">                                        
                                        <img class="avatar"  :src="mentor.avatar" />
                                    </div>
                                    <div class="col-xs-9 nopad header">
                                        <span
                                          class="name"
                                          :title="mentor.user.firstName + ' ' + mentor.user.lastName">
                                          {{mentor.user.firstName}} {{mentor.user.lastName}}
                                        </span>
                                        <span
                                          class="position"
                                          :title="mentor.position">
                                          {{mentor.position}}
                                        </span>
                                        <span
                                          class="company"
                                          v-if="mentor.company"
                                          :title="mentor.company.replace(/ and /g, ' &amp; ')">
                                          <a
                                            @click.stop
                                            :href="mentor.companyUrl"
                                            target="_blank">
                                            {{mentor.company.replace(/ and /g, ' &amp; ')}}
                                          </a>
                                        </span>                                        

                                    </div>
                                </div>
                                <div class="featured-image-wrapper">
                                    <v-lazy-image v-if="isValidImage(mentor.featuredImage)" class="featured-image" :src="mentor.featuredImage" />                                    
                                    <img v-else class="placeholder" src="../assets/img/logo-large.png">
                                    <div class="public-image" v-if="mentor.public  && (localStorage.roles.includes('OnlineDirector') || localStorage.roles.includes('CampusDirector'))">
                                        <img class="software-image" src="../assets/img/mentor-public.svg">
                                    </div>
                                    <span
                                        v-if="mentor.totalRequests > 0"
                                        class="past-mentees">Mentored {{mentor.totalRequests}}</span>
                                </div>
                    
                                    <div class="footer clearfix">
                                      <ul class="current-mentees" v-if="!localStorage.roles.includes('CampusStudent')" >
                                         <li v-for="n in mentor.mentor_availabilities[0].seats">
                                          <span class="checkbox">
                                            <i :class="{'green':(n-1) < mentor.user.mentor_requests.length}" class="fa fa-check"></i>
                                          </span>
                                         </li>
                                      </ul>

                                        <span class="link">View Profile</span>

                                    </div>
                            </div>
                            

                            </router-link>
                        </li>
                    </ul>

            </div>
        </div>

    </section>

</template>


<script>

import Aws from '../services/aws';
import mentors from '../services/mentors';
import terms from '../services/terms';
import FileSelect from './reusable/file-select';
import VLazyImage from 'v-lazy-image/v2';
import stringUtils from '../utils/strings';
import Loader from './widgets/Loader';

import UuidV4 from 'uuid/v4';
import toastr from 'toastr';
import _ from 'underscore';

export default {
    data() {
        return {
            loading: false,
            perfectMatch: {
                industry: "",
                availableTimes: "",
                availableDays: "",
                specialties: []
            },
            venueFilter: 'both',
            pathFilter: 'cgasset',
            specialties: ["character_modeling", "props_modeling", "lighting", "texturing", "vehicles", "generalist", "creatures", "environments", "look_dev", "character_animation", "art_direction", "compositing", "technical_director", "concept_art", "matte_painting","VFX/Real-Time_effects"],
            mentors: null,
            selectedMentor:null,
            selectionHasNotStarted: true,
            terms: null,
            selectedTerm: null,
        };
    },
    components:{
        VLazyImage,
        Loader,
    },
    created() {
        if (localStorage.roles.includes('Student') && localStorage.transitioned != 'true') {
            this.venueFilter = 'online';
        } 
        if (localStorage.roles.includes('CampusStudent') || localStorage.transitioned == 'true') {
            this.venueFilter = 'campus';
        }
    },
    async mounted() {
        await this.getTerms();
        this.getMentors();        

    },
    methods: {
        showMentor(mentor) {
            let show = false;

            if (this.isDirector) {
                if (this.pathFilter === 'houdini') {
                    if (mentor.allStudentPaths === true || mentor.user.path == 9200) {
                        if (this.venueFilter === 'both') {
                            show = true;
                        } else {
                            show = mentor.mentor_availabilities[0].venue === this.venueFilter || mentor.mentor_availabilities[0].venue === 'both'
                        }                    
                    }
                } else {
                    if (mentor.allStudentPaths === true || mentor.user.path != 9200) {
                        if (this.venueFilter === 'both') {
                            show = true;
                        } else {
                            show = mentor.mentor_availabilities[0].venue === this.venueFilter || mentor.mentor_availabilities[0].venue === 'both'
                        }                    
                    }
                }
            } else {
                if (this.venueFilter === 'both') {
                    show = true;
                } else {
                    show = mentor.mentor_availabilities[0].venue === this.venueFilter || mentor.mentor_availabilities[0].venue === 'both'
                }                    
            }
            return show;
        },
        isValidImage(url) {
            return stringUtils.isValidImage(url);
        },
        getTerms() {
            return terms.get(this).then((response) => {
                
                const now = new Date();

                this.terms = response.data.terms.filter((t) => {
                        return t.type === 'mentorship' && new Date(t.endDate) > now
                    }).sort((a,b)=>{
                    return new Date(a.startDate) - new Date(b.startDate);
                });

                
                this.selectedTerm = this.terms.find((t)=>{
                    return new Date(t.startDate) > now;
                }).id;                
                return true;
            });
        },
        isNotAvailable(mentor) {
            return mentor.user.mentor_requests.length >= mentor.mentor_availabilities[0].seats;
        },
        matchPercentage(mentor) {
            var self = this;
            let percentage = 100;
            if (this.perfectMatch.industry === '' && this.perfectMatch.availableTimes === '' && this.perfectMatch.availableDays === '' && this.perfectMatch.specialties.length === 0) {
                this.selectionHasNotStarted = true;
                return;
            }


            if (
                this.perfectMatch.industry !== ''
                && mentor.industry !== this.perfectMatch.industry
                && mentor.industry !== 'both') return 0;


            if (
                (mentor.availableDays !== this.perfectMatch.availableDays)
                && this.perfectMatch.availableDays !== 'both'
                && mentor.availableDays !== 'both') percentage -= 20;


            if (
                (mentor.availableTimes !== this.perfectMatch.availableTimes)
                && this.perfectMatch.availableTimes !== 'any'
                && mentor.availableTimes !== 'any') percentage -= 20;

            let pointsPerSpecialty = 60 / this.specialties.length;

            let specialtyPoints = 0;

            mentor.specialties.forEach(function(s) {
                if (self.perfectMatch.specialties.indexOf(s) > -1) {
                    specialtyPoints += pointsPerSpecialty;
                }
            });

            if (self.perfectMatch.specialties.length > 0 && specialtyPoints === 0) return 0;

            percentage += specialtyPoints;

            return percentage;

        },
        getMentors() {
            this.loading = true;
            this.mentors = null;            
            mentors.get(this, this.selectedTerm).then((response) => {                
                if (JSON.parse(localStorage.roles).includes('Admin')) {
                    this.mentors = response.data.mentors.map((m)=>{
                        
                        m.totalRequests = m.user.mentor_requests.filter(r => r.approvedByStudent === true && r.approvedByMentor === true).length;
                        m.user.mentor_requests = m.user.mentor_requests.filter(r => r.term === this.selectedTerm);
                        
                        return m;
                    }).filter((m)=>{
                        // const connections = m.mentor_connections.filter(c => c.termId == this.selectedTerm);
                        // console.log(connections)
                        const availability = m.mentor_availabilities.find(a => a.termId == this.selectedTerm && a.status === 'available');
                        if (availability) {
                            m.mentor_availabilities = [availability];                       
                        }                        

                        m.user.mentor_requests = m.user.mentor_requests.filter(r => r.term === this.selectedTerm && r.approvedByStudent && r.approvedByMentor);

                        return !m.archived && m.specialties.length > 0 && m.company && m.bio && m.avatar && m.featuredImage && availability;
                    });

                } else {
                    this.mentors = response.data.mentors.map((m)=>{                       
                        m.totalRequests = m.user.mentor_requests.length
                        m.user.mentor_requests = m.user.mentor_requests.filter(r => r.term === this.selectedTerm);
                        return m;
                    });

                }
                this.loading = false;
                if (this.$route.query && this.$route.query.q) {
                    this.$nextTick(()=>{                        
                        this.perfectMatch.specialties.push(this.$route.query.q);
                        const query = Object.assign({}, this.$route.query);
                        delete query.q;
                        this.$router.replace({ query });
                    });
                }
            }).catch((error) => {
                console.log(error);
                this.loading = false;
            });
        },
        setSpecialties(specialty) {
            let index = this.perfectMatch.specialties.indexOf(specialty);
            index === -1 ? this.perfectMatch.specialties.push(specialty) : this.perfectMatch.specialties.splice(index, 1)
        },
    },
    watch: {

        'perfectMatch': {
            handler(val) {
                console.log(val)
                var self = this;
                if (!self.mentors) return;
                let mentors = self.mentors;
                self.mentors = null;
                this.selectionHasNotStarted = false;
                mentors = mentors.map(function(m) {
                    m.percentage = self.matchPercentage(m);
                    return m;
                }).sort(function(a,b) {
                    return b.percentage - a.percentage;
                });
                self.mentors = mentors;
            },
            deep:true
        }
    },
    computed: {
        isDirector() {
            const roles = JSON.parse(localStorage.roles);
            return roles.includes('Director') || roles.includes('Admin') || roles.includes('OnlineDirector') || roles.includes('CampusDirector')
        },

        canSeeVenueOptions() {
            const roles = JSON.parse(localStorage.roles)
            if (roles.includes('Student')) {
                if (localStorage.transitioned == 'true') {
                    return false;
                } else {
                    return true;
                }
            } else if (roles.includes('CampusStudent')) {
                return false;
            } else {
                return true;
            }
        },
        connectionAllowed() {
            const settings = this.$store.getters.settings;
            let allowed = false;

            if (settings && settings.length > 0) {
                let overrides = settings.find((s)=>{return s.name=== 'mentorSelectorOverride'}).data;
                const overridden = overrides.includes(parseInt(localStorage.user_id));
                let setting;
                if (localStorage.roles.includes('CampusStudent') || localStorage.transitioned == 'true') {
                    setting = settings.find((s)=>{return s.name=== 'campusMentorSelectionAllowed'}).value;
                } else {
                    setting = settings.find((s)=>{return s.name=== 'onlineMentorSelectionAllowed'}).value;
                }
                let studentGroups = localStorage.group.split(',');
                let inCampusMentorshipGroup = (studentGroups.includes('21'));
                if (setting === true && (overridden === true || localStorage.terms.split(',').length === 3 || (localStorage.roles.includes('CampusStudent') && inCampusMentorshipGroup))) {
                    allowed = true;
                }
            }

            return allowed;
        },
    }


}

</script>

<style lang="scss" scoped>
    .placeholder {
        float:none;
        margin:0 auto;
        display:block;
    }
    .filters {
        padding: 0 1.2rem;
    }
    .public-image {
        position:absolute;
        bottom:1rem;
        left:1rem;
        width: 30px;
        height:auto;
    }

    h3.disabled {
        color: #ccc;
        font-weight: 100;
        line-height: 1.5em;
        padding:1rem;
    }

    .availability {
        width:700px;
        margin-bottom:2rem;
        flex-wrap:no-wrap;
        display:flex;
        align-items:center;
        justify-content:flex-start;
        input {
            display:none;
        }
        label {
            margin:1rem;
            color: #1a1a1a;
            padding: .4rem 1rem;
            cursor: pointer;
        }
        li input:checked + label {
            // font-weight:700!important;
        }
        li:nth-child(1) {
            label {
                background:darken(#1d91a2,20%);
            }
            input:checked + label {
                background: lighten(#1d91a2, 10%);
            }
        }
        li:nth-child(2) {
            label {
                background:darken(#2da21d,20%);
            }
            input:checked + label {
                background:lighten(#2da21d,10%);
            }
        }
        li:nth-child(3) {
            label {
                background:darken(#a24c1d,20%);
            }
            input:checked + label {
                background:lighten(#a24c1d,10%);
            }
        }
        li:nth-child(4) {
            label {
                background:darken(#b0b0b0,20%);
            }
            input:checked + label {
                background:lighten(#b0b0b0,10%);
            }
        }
    }
    .unavailable {
        opacity: .5;
    }
    .past-mentees {
        position:absolute;
        font-size:1.2rem;
        color:#fff;
        background:rgba(0,0,0,.4);
        padding:0 4px;
    }

    .current-mentees {
      height:4rem;
      background-color: transparent;
      margin-left:0px;
      float:left;
      li {
        background-color: transparent;
        float:left;
        position: relative;
        top:-9px;
        width:26px!important;
      }
      .checkbox {
        position: relative;
        border:2px solid #363636;
        width:20px;
        height:20px;
      }
      .fa-check {
          color:#333333;
          font-size: 18px;
          position: absolute;
          top: -1px;
          left: -1px;
          &.green {
            color:#2DA21D;
          }
      }
    }

    .featured-image-wrapper {
        position: relative;
    }
    .past-mentees {
        bottom:5px;
        right:5px;
    }
    .mentor .header {
        position: relative;
    }
    .modal-wrapper {
        position: fixed;
        top:0;
        left:0;
        width:100%;
        height:100%;
        z-index:999999;
        background: rgba(0,0,0,.75);
        display:flex;
        align-items:center;
        justify-content:center;
        .modal-box {
            width:500px;
            border:1px solid #fff;
            text-align:center;
            border:3px solid #111;
            background:#555;
            position: relative;
            background-position:center center;
            background-size:cover;
            background-repeat:no-repeat;
            &::after {
                display:block;
                content:'';
                background:rgba(50,50,50,.75);
                position: absolute;
                top:0;
                left:0;
                width:100%;
                height:100%;
                z-index: 1;
            }
            textarea {
                height:350px;
                border:2px solid black;
                box-shadow: inset 0px 0px 190px rgba(0,0,0,.5);
                background:#333;
            }
            .file-select {
                border:2px solid black;
                box-shadow: inset 0px 0px 190px rgba(0,0,0,.5);
                background:#333;
            }
            textarea, button, h3, .file-select {
                z-index: 999;
                position: relative;
            }
        }
        img {
          z-index: 999;
        }
        h3 {
            margin-top:85px;
            margin-bottom: 10px;
        }
        .template-selector {
          position: relative;
          z-index: 999;
          text-align: right;
          width: 400px;
          margin: 0 auto;

          ol {
            display: inline;
            list-style-type: none;
            margin: 0;
            padding: 0;
          }

          li {
            display: inline;
            &:not(:last-of-type)::after {
              content: '|';
            }
            &.selected {
              font-weight: bold;
            }
          }

          button {
            background: none;
            border: none;
            padding: 5px 3px;
            margin: 0;
            text-decoration: underline
          }
        }
        .avatar {
            width:150px;
            height:150px;
            object-fit: cover;
            position: absolute;
            top:-75px;
            left: calc(50% - 75px);
            border:2px solid #111;
        }
        textarea {
            resize:none;
            width:400px;
            height:280px;
            color:#fafafa;
            padding:10px;
        }
        .file-select {
          width: 400px;
          margin: 0 auto;
        }
        button {
            margin: 1rem auto 2rem;
            padding:5px 20px;
            border:1px solid #3cf;

        }
    }
    .match-percentage {
        &.green {
            color:green;
        }
        &.yellow {
            color:yellow;
        }
        &.red {
            color: red
        }
    }
    .footer {
        background:#111;
        font-size:1.4rem;
        padding:0 2px;


        .link {
            background:#555;
            padding:5px;
            margin:5px;
            color:#ededed;
            float:right;
        }
        button {
            padding:5px;
            background:#3cf;
            color:#1a1a1a;
            border:none;
            margin:0 5px;
            &.unavailable {
                background: #555;
            }
        }
    }
    .selector {
        padding:1rem;
        font-size:1.6rem;
        line-height:2em;
    }

    select {
        border:none;
        background:transparent;
        margin:0 1rem;
        display:inline-block;
        border-bottom: 1px solid #555;
    }
    option {
        background:#000;
    }
    .mentors {
        display:flex;
        flex-wrap:wrap;
        padding:10px;
        box-shadow:inset 0 0 200px 100px #222222;
        background-color:#666;
        .mentor {
            box-shadow:0px 0px 30px black;
            border:solid 1px #424242;
        }
        li {
            width:25%;
            padding:10px;
            background:transparent;
        }

        .avatar {
            width:70px;
            height:70px;
            object-fit:cover;
            filter: grayscale(100%);
        }
        .header {
            position:relative;
            background:#111;
            color:#fff;
            padding:.5rem;
            padding-left:1rem;
            span {
                display:block;
                margin:0;
                padding:0;
            }
            .name, .position {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .name {
                font-size: 1.7rem;
                font-weight:600;
            }
            .position {
                font-style:italic;
                font-size:1.2rem;
                font-weight:100;
            }
            .company a {
                display: block;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
        .featured-image {
            width:100%;
            height:120px;
            object-fit:cover;
        }

    }
    .specialties {
            padding:1rem 3rem;
            display:flex;
            flex-wrap:wrap;
            flex-direction:row;
            li {
                margin:1rem;
                background:#1a1a1a;
                padding:0;
                border:1px solid #555;
            }
            label {
                padding:5px 10px;
                margin:0;
                margin-top:-3px;
                cursor:pointer;
                font-weight:300!important;
            }
            input[type="checkbox"] {
                display:none;
            }

            input[type="checkbox"]:checked + label {
                background:#ccc;
                color:#1a1a1a;
                font-weight:700!important;
            }
        }

</style>

<style lang="scss">
  .mentor-selector {
    .modal-wrapper .file-list {
      grid-template-columns: repeat(3, 1fr);
    }
  }
</style>



// WEBPACK FOOTER //
// MentorSelector.vue?e3249cb8